export const exportFr = {
  csv: "Exporter en CSV",
  done: "%{smart_count} ligne exportée. |||| %{smart_count} lignes exportées.",
  forbidden: "Exportation réservée aux administrateurs.",
  failed: "L'exportation a échoué. Réessayez.",
};
